export default {
  SET_KEYWORDS_TABLE_DATA(state, payload) {
    state.keywordsTableData = payload.results || [];
    state.pagination.total = payload.count || 0;
  },
  SET_SUMMARY(state, payload) {
    state.summary = payload;
  },
  SET_TOP_KEYWORDS(state, payload) {
    state.topKeywords = payload;
  },
  SET_KEYWORDS(state, payload) {
    state.keywords = (payload && payload.results) || [];
    state.keywordsNextPage = (payload && payload.next) || null;
  },
  SET_KEYWORD_SEARCH(state, search) {
    state.keywordSearch = search;
  },
  APPEND_KEYWORDS(state, payload) {
    const newResults = (payload && payload.results) || [];
    state.keywords = [...state.keywords, ...newResults];
    state.keywordsNextPage = (payload && payload.next) || null;
  },
  SET_LOADING_MORE_KEYWORDS(state, value) {
    state.loadingMoreKeywords = value;
  },
  SET_KEYWORD_BY_DATE(state, payload) {
    state.keywordByDate = payload || [];
  },
  SET_LOADING(state, { key, value }) {
    state.loading[key] = value;
  },
  SET_PAGINATION(state, { page, pageSize }) {
    if (page !== undefined) state.pagination.page = page;
    if (pageSize !== undefined) state.pagination.pageSize = pageSize;
  },
  SET_SEARCH_STATS(state, stats) {
    state.searchStats = stats;
  },
  SET_ORDERING(state, ordering) {
    state.ordering = ordering;
  },
  SET_FILTERS(state, filters) {
    state.filters = { ...state.filters, ...filters };
  },
  RESET_DATA(state) {
    state.summary = null;
    state.topKeywords = null;
    state.keywords = [];
    state.keywordByDate = [];
    state.keywordsNextPage = null;
    state.keywordsTableData = [];
    state.pagination.total = 0;
    state.keywordSearch = "";
    state.loadingMoreKeywords = false;
    Object.keys(state.loading).forEach(key => {
      state.loading[key] = false;
    });
  }
};
